import { Dialog, Transition, TransitionChild } from '@headlessui/react';
import { cn } from '@vimond/theme/tailwind';
import { Fragment } from 'react';

type ModalProps = {
  closeModal: () => void;
  modalContent: React.ReactNode;
  showModal: boolean;
  transitionClass?: string;
};

const ModalDialog: React.FC<ModalProps> = ({
  closeModal,
  modalContent,
  showModal,
  transitionClass,
}) => {
  return (
    <Transition show={showModal} as={Fragment}>
      <Dialog
        open={showModal}
        as="div"
        className="relative z-[10000]"
        onClose={closeModal}
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={cn(
              'bg-black/40 fixed inset-0 transition-opacity',
              transitionClass,
            )}
          />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full text-center items-center justify-center p-4 sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              {modalContent}
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalDialog;
